module.exports = __webpack_public_path__ + "img/catherine.ff694a6c.jpg";